import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
interface InfoTipProps {
  content: React.ReactNode;
  label?: string;
  align?: 'left' | 'center' | 'right';
  width?: number;
}
export function InfoTip({
  content,
  label = 'More information',
  align = 'center',
  width = 280
}: InfoTipProps) {
  const [open, setOpen] = useState(false);
  const alignClass = align === 'left' ? 'left-0' : align === 'right' ? 'right-0' : 'left-1/2';
  return <span className="relative inline-flex" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} data-id="element-712" data-mp="8vcprc78aqb">
      <button type="button" aria-label={label} aria-expanded={open} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} onClick={e => {
      e.stopPropagation();
      setOpen(o => !o);
    }} onKeyDown={e => e.stopPropagation()} className="rounded-full text-ink-subtle transition-colors duration-150 hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy/30" data-id="element-713" data-mp="3sdpjbxp5820b">
        <InfoIcon className="h-3.5 w-3.5" data-id="element-714" data-mp="18e2b1li11ag8" />
      </button>
      <AnimatePresence data-id="element-715" data-mp="to4mh4g6qiqi">
        {open && <motion.span role="tooltip" initial={{
        opacity: 0,
        y: -3
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -3
      }} transition={{
        duration: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} style={{
        width,
        x: align === 'center' ? '-50%' : 0
      }} className={`absolute top-full z-50 mt-2 block rounded-md bg-ink px-3 py-2.5 text-left text-xs font-normal normal-case leading-relaxed tracking-normal text-white shadow-lg ${alignClass}`} data-id="element-716" data-mp="tpfmct6if6cc">
            {content}
          </motion.span>}
      </AnimatePresence>
    </span>;
}